/**
 * Транслитерация кириллицы и генерация slug из человекочитаемого названия.
 *
 * Используется в модалках создания (пространство/тип записи/поле), чтобы slug
 * автозаполнялся из названия, как в модалке пространства. Разделитель
 * параметризуется: типы/пространства используют дефис (`demo-goals`), а поля —
 * underscore (`my_field`), потому что у них разные правила валидации slug.
 */
const CYRILLIC_TO_LATIN: Record<string, string> = {
  а: 'a', б: 'b', в: 'v', г: 'g', д: 'd', е: 'e', ё: 'e', ж: 'zh', з: 'z',
  и: 'i', й: 'y', к: 'k', л: 'l', м: 'm', н: 'n', о: 'o', п: 'p', р: 'r',
  с: 's', т: 't', у: 'u', ф: 'f', х: 'kh', ц: 'ts', ч: 'ch', ш: 'sh',
  щ: 'sch', ъ: '', ы: 'y', ь: '', э: 'e', ю: 'yu', я: 'ya',
};

/**
 * Превращает название в slug: транслит кириллицы, нижний регистр, замена
 * всего не-[a-z0-9] на `separator`, обрезка разделителей по краям.
 */
export function slugify(value: string, separator: '-' | '_' = '-'): string {
  const sep = separator;
  const escaped = sep === '-' ? '\\-' : sep;
  return value
    .trim()
    .toLowerCase()
    .split('')
    .map((char) => CYRILLIC_TO_LATIN[char] ?? char)
    .join('')
    .replace(/[^a-z0-9]+/g, sep)
    .replace(new RegExp(`^${escaped}+|${escaped}+$`, 'g'), '');
}
